<div class="p-4">
  <h1 class="leading-8 mb-1">Trusted browsers</h1>
  <p class="leading-5">
    Browsers that do not require two-factor authentication (2FA) to complete sign-in flow. You should only trust
    browsers installed on your own computer.
  </p>
  <mat-divider class="!mt-4 !mb-8"></mat-divider>

  <div class="px-4 bg-white mat-elevation-z1">
    <table mat-table class="w-full" [dataSource]="pagedDataSource">
      <ng-container matColumnDef="browser">
        <th mat-header-cell *matHeaderCellDef>Browser</th>
        <td mat-cell *matCellDef="let item">{{ item.device.data.browser }} ({{ item.device.data.os }})</td>
      </ng-container>

      <ng-container matColumnDef="ipAddress">
        <th mat-header-cell *matHeaderCellDef>IP address</th>
        <td mat-cell *matCellDef="let item">{{ item.device.data.ipAddress }}</td>
      </ng-container>

      <ng-container matColumnDef="datetime">
        <th mat-header-cell *matHeaderCellDef>Date/Time</th>
        <td mat-cell *matCellDef="let item">{{ item.device.createdDateTime | userDate }}</td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Action</th>
        <td mat-cell *matCellDef="let item">
          <div class="invisible group-hover:visible">
            <button
              mat-icon-button
              *ngIf="!item.revoke"
              color="warn"
              (click)="revoke(item)"
              [loading]="item.processing"
            >
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="loading">
        <td mat-footer-cell *matFooterCellDef colspan="99">
          <div class="flex justify-center">
            <mat-spinner [diameter]="25" [strokeWidth]="2"></mat-spinner>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row class="group" *matRowDef="let row; columns: displayedColumns"></tr>
      <tr *matNoDataRow [hidden]="loading">
        <td class="text-center text-[#757575]" colspan="99">There is no trusted browser</td>
      </tr>
      <tr mat-footer-row *matFooterRowDef="['loading']" [hidden]="!loading"></tr>
    </table>

    <mat-paginator
      (page)="pageChanged($event)"
      [length]="dataSource.data.length"
      [pageIndex]="pageStart - 1"
      [pageSize]="pageOffset"
      hidePageSize
      showFirstLastButtons
      *ngIf="trustedDevices.length"
    ></mat-paginator>
  </div>
</div>
